// Mock data for MapMyKid by Addrish Software Solutions Pvt Ltd
// NOTE: This is MOCK data used for the frontend-only build.

export const company = {
  name: "MapMyKid",
  legal: "Addrish Software Solutions Pvt Ltd",
  tagline: "Discover & Develop the True Potential of your Child",
  email: "mapmykid@gmail.com",
  phones: ["9872977717", "6283300331"],
};

export const LINKS = {
  login: "https://login.mapmykid.com/",
  assessmentPay: "https://rzp.io/rzp/Ktp6PYvC",
};

export const stats = [
  { value: "Global", label: "Presence & Research" },
  { value: "Nur to 12", label: "Age Coverage" },
  { value: "For Parents", label: "Who Truly Care" },
  { value: "For Schools", label: "With A Future Vision" },
];

export const assessments = [
  {
    id: "3-8",
    tag: "Core Development",
    ages: "Ages 8 to 13",
    title: "Grade 3 to Grade 8",
    price: "₹2,500",
    worksheets: "500 SuperSkill Worksheets included",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_assess-launch-1/artifacts/3h8472oz_grade5.png",
    summary:
      "Digital assessment conducted in two parts. Duration ~60 minutes. Part A by the student, Part B by the parent.",
    duration: "~60 minutes",
    indices: [
      "Focus-Concentration Index",
      "Intellect and Memory (Dynamic IQ) Index",
      "Processing Speed Index (Decision Making Ability)",
      "Creativity Acumen Index (CQ)",
      "Natural Ability, Strengths and Talent",
      "Mental Efficiency and Multiple Intelligence Level",
    ],
    parts: [
      { name: "Part A (students)", detail: "80 to 100 objective questions" },
      { name: "Part B (parents)", detail: "80 questions answered in yes / no" },
    ],
  },
  {
    id: "nur-2",
    tag: "Early Foundations",
    ages: "Ages 3 to 7",
    title: "Nursery to Grade 2",
    price: "₹2,500",
    worksheets: "500 SuperSkill Worksheets included",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_assess-launch-1/artifacts/eu0f0q59_grade-nursery.png",
    summary:
      "Digital assessment conducted in two parts. Duration ~60 minutes. Total questions: 134, all asked about the child and answered by the parents in yes / no.",
    duration: "~60 minutes",
    indices: [
      "Emotional Growth Index",
      "Intellectual Growth Index",
      "Social Intelligence Index",
      "Physical Intelligence Index",
      "Natural Ability, Strengths and Talent",
      "Relative Growth Index and Multiple Intelligence Levels",
    ],
    parts: [
      { name: "Total questions", detail: "134 questions, answered in yes / no" },
      { name: "Answered by", detail: "Parents, on behalf of the child" },
    ],
  },
  {
    id: "9-12",
    tag: "Stream & Career",
    ages: "Ages 14 to 18",
    title: "Grade 9 to Grade 12",
    price: "₹2,500",
    worksheets: "500 SuperSkill Worksheets included",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_assess-launch-1/artifacts/gpk8cz3u_grade10.png",
    summary:
      "Digital assessment conducted in two parts. Duration ~60 minutes. Both parts are attempted by the student.",
    duration: "~60 minutes",
    indices: [
      "Natural Ability, Strengths and Talent",
      "Career Choices and Stream Selection Recommendation",
      "Focus-Concentration Index",
      "Intellect-Memory (Dynamic IQ) Index",
      "Processing Speed Index (Decision Making Ability)",
      "Mental Efficiency and Multiple Intelligences Level",
    ],
    parts: [
      { name: "Part A", detail: "100 objective questions (four options each)" },
      { name: "Part B", detail: "80 questions answered in yes / no" },
    ],
  },
];

export const steps = [
  {
    no: "01",
    title: "Choose the Age Bracket",
    desc: "Pick the assessment matched to your child's grade: Nursery to 2, 3 to 8, or 9 to 12.",
    meta: "2 minutes",
  },
  {
    no: "02",
    title: "Take the Digital Assessment",
    desc: "A 60 minute science backed test taken online at home. Parent and / or child respond as guided.",
    meta: "~60 minutes",
  },
  {
    no: "03",
    title: "Receive the Cognitive Profile",
    desc: "An instant, detailed report of strengths, gaps, learning speed, natural aptitudes and multiple intelligence.",
    meta: "Instant",
  },
  {
    no: "04",
    title: "Follow CogniSol Worksheets",
    desc: "Personalised non academic worksheets that systematically strengthen the underlying mental skills.",
    meta: "Ongoing",
  },
];

export const comparison = [
  { metric: "What is measured", trad: "Academic scores", mmk: "Underlying cognitive abilities" },
  { metric: "Focus", trad: "Marks & rank", mmk: "Focus, memory, reasoning, creativity, speed" },
  { metric: "Report", trad: "Report card", mmk: "Full cognitive profile plus learning style" },
  { metric: "Action after result", trad: "Tuition & repetition", mmk: "Personalised CogniSol worksheets" },
  { metric: "Outcome", trad: "Short term marks", mmk: "Lifelong learning capacity" },
];

export const abilities = [
  { icon: "Brain", title: "Intellect & Memory", desc: "The Dynamic IQ that shows how your child grasps, retains and applies knowledge." },
  { icon: "Target", title: "Focus & Concentration", desc: "How well your child holds attention, filters distractions and sustains engagement." },
  { icon: "Gauge", title: "Decision Making Speed", desc: "Processing speed and accuracy while making choices under time and information." },
  { icon: "Sparkles", title: "Natural Ability & Strengths", desc: "The innate talents and areas where your child is naturally wired to excel." },
  { icon: "Rocket", title: "Learning Speed", desc: "The pace at which your child absorbs and masters something new." },
  { icon: "Layers", title: "Cognitive Capacity", desc: "The overall mental bandwidth available for thinking, reasoning and doing." },
  { icon: "Lightbulb", title: "Creativity Acumen (CQ)", desc: "The ability to generate original ideas, associations and solutions." },
  { icon: "Scale", title: "Self-Estimation Levels", desc: "How accurately your child perceives their own abilities and confidence." },
];

export const credentials = [
  { badge: "Presented", title: "Reimagine Education Forum", place: "San Francisco, USA" },
  { badge: "Appreciated", title: "Startup Grind by Google", place: "California, USA" },
  { badge: "Presented", title: "ICARSS", place: "London, UK" },
  { badge: "Published", title: "European Journal of Behavioral Sciences", place: "Europe" },
  { badge: "Published", title: "International Journal of Indian Psychology", place: "India" },
];

export const testimonials = [
  {
    quote:
      "The assessment clearly mapped my son's natural ability and where his focus was slipping. For the first time we understood how he actually thinks, not just his marks.",
    name: "Priya Sharma",
    role: "Parent",
    avatar:
      "https://images.pexels.com/photos/17450830/pexels-photo-17450830.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=200&h=200",
  },
  {
    quote:
      "The cognitive profiles gave us real clarity on each student's strengths and learning speed. It changed how we plan our classroom activities.",
    name: "Ritu Malhotra",
    role: "Educator",
    avatar:
      "https://images.unsplash.com/photo-1749700332031-cf99864959ea?crop=faces&fit=crop&w=200&h=200&q=85&fm=jpg",
  },
  {
    quote:
      "Before Grade 10 stream selection, the assessment showed my daughter was wired for design and spatial thinking. The clarity was priceless.",
    name: "Vikram Nanda",
    role: "Parent",
    avatar:
      "https://images.unsplash.com/photo-1757744705465-ea08b0ddc38a?crop=entropy&cs=srgb&fm=jpg&q=85&w=200&h=200&fit=crop",
  },
];

export const faqs = [
  {
    q: "How is MapMyKid different from an IQ test?",
    a: "An IQ test gives a single number. MapMyKid produces a full cognitive profile: intellect and memory, focus, decision making speed, creativity, natural ability, learning speed and self-estimation, mapped to the child's age. It is a development tool, not a labelling tool.",
  },
  { q: "How long does the assessment take?", a: "Each assessment takes about 60 minutes and is taken online from the comfort of your home." },
  { q: "When do we get the report?", a: "The detailed cognitive profile is generated instantly once the assessment is completed." },
  { q: "What are CogniSol worksheets?", a: "Personalised, non academic worksheets designed to systematically strengthen the underlying mental skills identified in the report." },
  { q: "Is the science credible?", a: "Yes. Our advanced cognitive science methodology has been presented and published across the USA, UK, Europe and India at respected education and behavioral science forums." },
  { q: "Do schools use MapMyKid?", a: "Absolutely. Hundreds of partner schools use MapMyKid to understand learning styles and plan better classroom activities." },
  { q: "Can I run this as a business?", a: "Yes. Our partner program lets entrepreneurs, coaching centres and educators launch their own MapMyKid brand with full training, tools and support." },
];

export const partnerBenefits = [
  { icon: "Rocket", title: "Launch In Weeks", desc: "A ready to run playbook, digital platform and brand kit so you can start assessments fast." },
  { icon: "GraduationCap", title: "Full Training", desc: "Hands on onboarding on the science, the platform and how to counsel parents with confidence." },
  { icon: "IndianRupee", title: "Strong Margins", desc: "Recurring revenue from assessments and CogniSol worksheet subscriptions." },
  { icon: "LifeBuoy", title: "Ongoing Support", desc: "Dedicated success manager, marketing assets and product updates every quarter." },
  { icon: "MapPin", title: "Exclusive Territory", desc: "Protected geography so you build your brand without internal competition." },
  { icon: "TrendingUp", title: "Proven Demand", desc: "Parents and schools are actively looking for clarity beyond marks." },
];

export const schoolBenefits = [
  { icon: "Users", title: "Whole Cohort Insights", desc: "Understand every learner's style and plan differentiated classroom activities." },
  { icon: "ClipboardList", title: "Easy Rollout", desc: "Assessments run online during a single period, no infrastructure headaches." },
  { icon: "BarChart3", title: "Actionable Analytics", desc: "School level dashboards that reveal focus, memory and creativity trends." },
  { icon: "HeartHandshake", title: "Parent Engagement", desc: "Give parents a meaningful report that builds trust in your institution." },
];

export const partnerSteps = [
  { no: "01", title: "Apply & Connect", desc: "Share your background and goals. Our team maps the opportunity in your area." },
  { no: "02", title: "Onboard & Train", desc: "Get certified on the platform, the science and parent counselling." },
  { no: "03", title: "Launch Your Centre", desc: "Go live with brand assets, marketing support and your assessment platform." },
  { no: "04", title: "Grow With Us", desc: "Scale assessments, worksheet subscriptions and school tie ups." },
];

export const partnerVision = {
  eyebrow: "A MapMyKid Partnership",
  title: "Build a cognitive-tech business for the AI age.",
  body: "The world is rapidly transitioning into an Artificial Intelligence driven future. Success will depend not only on knowledge, but on cognitive abilities: critical thinking, problem solving, creativity, decision making, adaptability and the ability to keep learning. Our mission is to help children discover their natural abilities, and to empower educators and entrepreneurs to build their own cognitive assessment and development businesses under their own brand.",
};

export const partnerOpportunity = [
  { icon: "Users", title: "Empower Parents & Schools", desc: "Help families and schools finally understand how their children truly think, learn and grow." },
  { icon: "TrendingUp", title: "A Massive Market", desc: "Millions of children across every city and thousands of schools, with fast growing demand for clarity beyond marks." },
  { icon: "Building2", title: "Run It From Anywhere", desc: "No office, staff or location required. Introduce MapMyKid online, in schools and social groups." },
  { icon: "IndianRupee", title: "Earn A Big Income", desc: "A mission with real social impact gives you every right to build a strong, rewarding income." },
];

export const partnerHighlights = [
  "No office, staff or location required",
  "Introduce online, in schools, meetings, social media & WhatsApp groups",
  "A huge market of millions of children and thousands of schools",
  "Real social impact that empowers parents and schools",
  "Strong, rewarding income potential",
];

export const partnerPlans = [
  {
    name: "Elite Partner",
    tagline: "Start conducting instantly",
    yearly: "50,000",
    quarterly: "18,000",
    priceNote: "Inclusive of GST",
    popular: false,
    canPay: true,
    rzpButtonId: "pl_TdoTy8uOOcbmez",
    features: [
      { t: "Unlimited assessments to conduct", ok: true },
      { t: "Own pricing freedom (no restrictions)", ok: true },
      { t: "Unlimited discount coupons", ok: true },
      { t: "Collect payments on your own", ok: true },
      { t: "India operations", ok: true },
      { t: "Full video training & business license", ok: true },
    ],
  },
  {
    name: "Pro Partner",
    tagline: "Your own ed-tech brand, worldwide",
    yearly: "80,000",
    quarterly: "30,000",
    priceNote: "Inclusive of GST",
    popular: true,
    canPay: true,
    rzpButtonId: "pl_Tdoah25Vkdn78v",
    features: [
      { t: "Everything in Elite Partner, all Unlimited", ok: true },
      { t: "Own domain & landing page website", ok: true },
      { t: "Own logo & branding", ok: true },
      { t: "Global operations enabled", ok: true },
      { t: "Own payment collection", ok: true },
      { t: "Add-on school & business dashboards (₹30,000 / year)", ok: true },
      { t: "Unlimited coupons, pricing & school packages", ok: true },
    ],
  },
  {
    name: "Prime Pro Partner",
    tagline: "Exclusive rights for your region",
    yearly: "2.5 Lakh",
    yearlyPrefix: "from",
    quarterly: null,
    priceNote: "Onwards, depends on region / city / state. Inclusive of GST",
    popular: false,
    canPay: false,
    rzpButtonId: "",
    features: [
      { t: "Everything in Pro Partner, all Unlimited", ok: true },
      { t: "Exclusive rights for your region / city", ok: true },
      { t: "Sub-franchising allowed", ok: true },
      { t: "Protected territory, no internal competition", ok: true },
      { t: "Own domain, branding & global operations", ok: true },
    ],
  },
];

export const businessTestimonials = [
  {
    quote:
      "Starting from home in Mumbai, I took the Prime Pro plan for exclusive city rights and now sub-franchise across the region. Knowing I am helping thousands of children find their strengths makes this deeply rewarding.",
    name: "Sunil Patil",
    city: "Mumbai",
    role: "MapMyKid Partner, Mumbai",
  },
  {
    quote:
      "In Coimbatore I introduce MapMyKid through schools and social media. Parents are genuinely grateful for the clarity, and the demand keeps growing. It has become a strong, meaningful income for me.",
    name: "Vaidhynath",
    city: "Coimbatore",
    role: "MapMyKid Partner, Coimbatore",
  },
  {
    quote:
      "As a working parent in Patna, I run everything through WhatsApp groups and online meetings. Empowering other families to understand their children, and earning well while doing it, is the best of both worlds.",
    name: "Vivek Rajan",
    city: "Patna",
    role: "MapMyKid Partner, Patna",
  },
  {
    quote:
      "I began in Noida with no office and no staff. Within months I was conducting assessments across schools. The social impact is huge, and so is the opportunity to build a serious income.",
    name: "Rajni Seth",
    city: "Noida",
    role: "MapMyKid Partner, Noida",
  },
];

export const partnerFaqs = [
  { q: "What exactly do you provide?", a: "We provide everything on the technology side plus soft collateral support. You introduce MapMyKid in schools or on digital and social media, capture leads and build your own client base." },
  { q: "Can I set my own prices?", a: "Yes. There is no restriction on pricing, the number of assessments, licenses or school packages. You design the offering your way." },
  { q: "Do I need an office or staff?", a: "Not at all. You can run the business entirely online, introducing MapMyKid in schools, online meetings, social media and WhatsApp groups. There is no office or fixed setup to worry about." },
  { q: "What training do I get?", a: "You receive full video-based training: understanding the assessments, guidance and counselling, and a license to conduct this business." },
  { q: "How does the subscription work?", a: "You subscribe to a plan every year and continue doing business. Elite and Pro partners can also renew quarterly. All plans are inclusive of GST." },
  { q: "When does my plan start?", a: "Your plan duration begins 15 days after payment. However, you receive your dashboard the same day so you can start conducting assessments immediately." },
  { q: "Is there a refund?", a: "All payments received are non-refundable under all circumstances, across every plan." },
  { q: "What about sub-franchising?", a: "Sub-franchising is available exclusively with the Prime Pro Partner plan, which also grants exclusive rights for your region or city." },
];

export const partnerReceives = [
  "Own domain name",
  "Own brand name & logo",
  "Business page website",
  "Mobile friendly design",
  "Search engine optimised (SEO)",
  "Customised language & content",
  "Own About Us page",
  "Own Vision & Mission",
  "Add-on services page",
  "Payments via own UPI / Razorpay / banking",
  "Cognitive assessment platform linking",
  "Marketing collaterals & guidance",
];

export const partnerChannels = [
  { icon: "Globe2", t: "Own website" },
  { icon: "Users", t: "Direct parent counselling" },
  { icon: "Presentation", t: "Workshops" },
  { icon: "School", t: "School tie-ups" },
  { icon: "Share2", t: "Social media campaigns" },
  { icon: "Megaphone", t: "Digital marketing" },
  { icon: "CalendarDays", t: "Educational events" },
];

// In-app videos (embedded via modal player). type: "mp4" | "youtube"
export const videos = [
  {
    type: "mp4",
    src: "https://customer-assets-jai6qajn.emergentagent.net/job_assess-launch-1/artifacts/gzoynmvw_Assessment-Process.mp4",
    poster: "https://customer-assets-jai6qajn.emergentagent.net/job_assess-launch-1/artifacts/sbsrzyfz_herobanner.png",
    title: "How the Assessment Works",
    desc: "Understand the entire MapMyKid assessment in under 2 minutes.",
  },
];

export const heroImages = {
  main:
    "https://customer-assets-jai6qajn.emergentagent.net/job_assess-launch-1/artifacts/sbsrzyfz_herobanner.png",
  classroom:
    "https://images.pexels.com/photos/22616347/pexels-photo-22616347.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  learning:
    "https://images.pexels.com/photos/20556417/pexels-photo-20556417.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
};

export const pageImages = {
  teacher:
    "https://images.pexels.com/photos/18870256/pexels-photo-18870256.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  classroom:
    "https://images.pexels.com/photos/22616347/pexels-photo-22616347.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  business:
    "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  womanPresenting:
    "https://customer-assets-jai6qajn.emergentagent.net/job_assess-launch-1/artifacts/l4h2kkg4_business-page-hero.png",
  entrepreneur:
    "https://customer-assets-jai6qajn.emergentagent.net/job_assess-launch-1/artifacts/5zstfb9o_business-page-2.png",
};


export const timeSlots = [
  "09:00 AM",
  "11:00 AM",
  "01:00 PM",
  "03:00 PM",
  "05:00 PM",
  "07:00 PM",
];

// Original blog / insights articles on child cognition (own words, SEO friendly)
export const articles = [
  {
    slug: "why-cognitive-skills-matter-more-than-marks",
    title: "Why cognitive skills matter more than marks",
    category: "Cognitive Science",
    date: "July 2025",
    readTime: "6 min read",
    image:
      "https://images.pexels.com/photos/8535163/pexels-photo-8535163.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    excerpt:
      "Marks tell you what a child scored on a given day. Cognitive skills tell you how a child thinks, learns and adapts, for life.",
    body: [
      "For decades, a report card has been the main way families judge how a child is doing at school. Yet a single number can hide far more than it reveals. Two children can score the same marks in a subject while thinking in completely different ways. One might rely on a strong memory, another on quick reasoning, and a third on sheer effort the night before an exam. Marks flatten all of this into one figure.",
      "Cognitive skills are the underlying mental abilities that make learning possible: memory and intellect, focus and concentration, decision-making speed, creativity and the capacity to keep learning. Unlike marks, these skills travel with a child across subjects, exams and eventually into work and life. A child with strong focus and flexible reasoning can pick up new topics quickly, while a child who has memorised answers may struggle the moment questions change form.",
      "This is why understanding a child's cognitive profile early is so valuable. When parents and teachers can see how a child naturally processes information, they can support them in the right way, instead of simply pushing for more practice. A creative child may thrive with open-ended projects; a child with slower processing speed may simply need more time, not more pressure.",
      "None of this means marks are useless. They remain a useful signal. But they are a lagging one. Cognitive insight is a leading indicator; it shows you the engine under the bonnet, not just the distance already travelled. When you develop the engine, the marks tend to follow, and more importantly, so does a confident, capable mind.",
    ],
  },
  {
    slug: "the-right-age-to-assess-your-child",
    title: "The right age to assess your child",
    category: "Parenting",
    date: "July 2025",
    readTime: "5 min read",
    image:
      "https://images.pexels.com/photos/8471799/pexels-photo-8471799.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    excerpt:
      "Assessing at the right age turns insight into action, giving families years to nurture strengths and support gaps.",
    body: [
      "One of the most common questions parents ask is when they should first understand their child's cognitive strengths. The honest answer is: earlier than most people think. The early years are when the brain is most adaptable, and small, well-timed support can compound into big differences over time.",
      "In the foundation years, from nursery to early primary, assessment is less about testing and more about observation. A gentle, parent-answered assessment can reveal a child's emotional growth, social intelligence and early signs of natural ability. This gives families a warm, pressure-free starting point rather than a label.",
      "As children move into the middle grades, they can respond to assessments themselves. Here you begin to see focus, memory, processing speed and creativity more clearly. This is a powerful window: there is still plenty of time to strengthen weaker areas and lean into strengths before the pressure of senior school arrives.",
      "By the time a child reaches Grades 9 to 12, assessment becomes a compass for big decisions, stream selection and career direction. Understanding natural aptitude here can save years of trial and error. The key idea across every age is the same: assess early, assess often, and use what you learn to develop, not to judge.",
    ],
  },
  {
    slug: "how-to-nurture-focus-in-a-distracted-world",
    title: "How to nurture focus in a distracted world",
    category: "Learning",
    date: "July 2025",
    readTime: "7 min read",
    image:
      "https://images.pexels.com/photos/4145153/pexels-photo-4145153.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    excerpt:
      "Focus is a skill, not a personality trait. With the right habits, most children can strengthen it steadily.",
    body: [
      "Focus and concentration are among the strongest predictors of how smoothly a child learns, yet they are also under the most pressure in a world of endless notifications and quick entertainment. The good news is that attention is trainable. Like a muscle, it grows with the right kind of practice and rest.",
      "Start with the environment. A calm, clutter-free study space with a single task in view helps far more than willpower alone. Short, focused sessions with clear start and stop points teach the brain to engage fully and then recover, rather than drifting for hours at half-attention.",
      "Next, protect deep work from interruptions. Even brief distractions carry a hidden cost, because the mind needs time to settle back into a task. Simple routines, such as a fixed study time, a visible timer and a phone kept in another room, remove dozens of tiny decisions that would otherwise drain a child's attention.",
      "Finally, connect focus to meaning. Children concentrate best when a task feels relevant and appropriately challenging. Understanding a child's cognitive profile helps here: it shows whether attention slips because work is too easy, too hard, or simply presented in a way that does not suit how they learn. With that insight, focus stops being a daily battle and becomes a skill you build together.",
    ],
  },
  {
    slug: "beyond-iq-understanding-multiple-intelligence",
    title: "Beyond IQ: understanding multiple intelligence",
    category: "Cognitive Science",
    date: "July 2025",
    readTime: "6 min read",
    image:
      "https://images.pexels.com/photos/8535230/pexels-photo-8535230.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    excerpt:
      "A single IQ number cannot capture the many ways children are intelligent. Multiple intelligence offers a richer map.",
    body: [
      "For a long time, intelligence was treated as one fixed quantity, summed up in a single IQ score. But anyone who has spent time with children knows how limiting that view is. One child sketches beautifully but finds spelling hard; another solves puzzles instantly but is shy in a group; a third leads naturally and reads people with ease.",
      "The idea of multiple intelligence suggests that intelligence shows up in many forms, linguistic, logical, spatial, musical, interpersonal and more. Rather than asking how intelligent a child is, it asks how a child is intelligent. That shift in question changes everything about how we support them.",
      "When you map a child's profile across several kinds of intelligence, strengths that a marksheet would never notice suddenly become visible. A child who struggles with rote learning may have exceptional spatial or creative ability that, once recognised, can be channelled into confidence and achievement.",
      "This is not about handing out labels or excusing weak areas. It is about giving every child a fair chance to be seen fully. When parents and teachers understand the whole shape of a child's mind, they can build on real strengths while patiently supporting the gaps, and help each child grow into the most capable version of themselves.",
    ],
  },
];
